import { z } from 'zod';

/**
 * Mirrors `emailInstituteSchema` and the attachment rules in the API's
 * `institutes.validation.ts`. The server is the authority; these are here so
 * the composer can say what is wrong before anything is uploaded.
 */

/** A PDF or a picture. SVG is refused, as on the server — it can carry script. */
export const EMAIL_ATTACHMENT_TYPES = ['application/pdf', 'image/png', 'image/jpeg', 'image/webp'] as const;
export const EMAIL_ATTACHMENT_LABEL = 'PDF, PNG, JPG or WEBP';
export const MAX_EMAIL_ATTACHMENTS = 5;
/** Per file — the API's `MAX_UPLOAD_MB`. */
export const MAX_EMAIL_ATTACHMENT_MB = 5;
/** All files together — what a mail provider reliably accepts once encoded. */
export const MAX_EMAIL_TOTAL_MB = 10;

export const emailInstituteSchema = z.object({
  subject: z
    .string()
    .trim()
    .min(1, 'Add a subject')
    .max(150, 'Keep the subject under 150 characters')
    .refine((value) => !/[\r\n]/.test(value), 'The subject must be a single line'),
  message: z
    .string()
    .trim()
    .min(1, 'Write a message')
    .max(5000, 'Keep the message under 5,000 characters'),
});

export type EmailInstitutePayload = z.infer<typeof emailInstituteSchema>;
